import { trigger, transition, style, query, animateChild, group, animate } from '@angular/animations';

export const routeTransitionAnimations = trigger('triggerName', [
	transition('login => estructura', [
		style({ position: 'relative' }),
		query(':leave, :enter', [
			style({
				position: 'fixed',
				top: 0,
				right: 0,
				bottom: 100,
				width: '100%',
				height: '100%'
			})
		]),
		query(':leave',  [
			style({
				transform: 'translateY(0%)'
			})
		]),
		query(':enter',animateChild()),
		group([
			query(':leave', [
				style({ position: 'absolute', zIndex: 9999 }),
				animate('600ms ease-out', style({
					transform: 'translateY(-100%)'
				}))
			]),
			query(':enter', [
				style({ position: 'relative', zIndex: 1 })
			])
		]),
		query(':enter', animateChild())
	]),
	transition('estructura => login', [
		style({ position: 'relative' }),
		query(':enter, :leave', [
			style({
				position: 'absolute',
				top: 0,
				left: 0,
				bottom: 0,
				width: '100%',
				height: '100%'
			})
		]),
		query(':enter', [
			style({
				transform: 'translateY(-100%)'
			})
		]),
		query(':leave', animateChild()),
		group([
			query(':enter', [
				animate('600ms ease-out', style({
					transform: 'translateY(0%)'
				}))
			]),
			query(':leave', [
				animate('600ms ease-out', style({
					transform: 'translateY(0%)'
				}))
			])
		]),
		query(':enter', animateChild())
	])
]);

export const routeTransitionEstructura = trigger('triggerName', [
	transition('principal => detalle', [
		style({ position: 'relative' }),
		query(':enter, :leave', [
			style({
				position: 'absolute',
				top: 0,
				right: 0,
				width: '100%',
				height: '100%'
			})
		]),
		query(':enter', [style({ right: '-100%', opacity: 0 })]),
		query(':leave', animateChild()),
		group([
			query(':leave', [animate('600ms ease-out', style({ right: '100%', opacity: 0 }))]),
			query(':enter', [animate('600ms ease-out', style({ right: '0%', opacity: 1 }))])
		]),
		query(':enter', animateChild())
	])
	,
	transition('detalle => principal', [
		style({ position: 'relative' }),
		query(':enter, :leave', [
			style({
				position: 'absolute',
				top: 0,
				left: 0,
				width: '100%',
				height: '100%',
			})
		]),
		query(':enter', [style({ left: '-100%' })]),
		query(':leave', animateChild()),
		group([
			query(':leave', [animate('600ms ease-out', style({ left: '100%' }))]),
			query(':enter', [animate('600ms ease-out', style({ left: '0%' }))])
		]),
		query(':enter', animateChild())
	]),
	transition('principal => nueva', [
		style({ position: 'relative' }),
		query(':leave, :enter', [
			style({
				position: 'fixed',
				top: 0,
				right: 0,
				bottom: 100,
				width: '100%',
				height: '100%'
			})
		]),
		query(':enter',  [
			style({
				transform: 'translateY(100%)'
			})
		]),
		query(':leave',animateChild()),
		group([
			query(':enter', [
				style({ position: 'absolute', zIndex: 9999 }),
				animate('600ms ease-out', style({
					transform: 'translateY(0%)'
				}))
			]),
			query(':leave', [
				style({ position: 'relative', zIndex: 1 })
			])
		]),
		query(':enter', animateChild())
	]),
	transition('nueva => principal', [
		style({ position: 'relative' }),
		query(':enter, :leave', [
			style({
				position: 'fixed',
				top: 0,
				left: 0,
				bottom: 100,
				width: '100%',
				height: '100%'
			})
		]),
		query(':leave', [
			style({
				transform: 'translateY(0%)'
			})
		]),
		query(':enter', animateChild()),
		group([
			query(':leave', [
				style({ position: 'absolute', zIndex: 9999 }),
				animate('600ms ease-out', style({
					transform: 'translateY(100%)'
				}))
			]),
			query(':enter', [
				style({ position: 'relative', zIndex: 1 })
			])
		]),
		query(':enter', animateChild())
	])
]);